import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/components/Home'
import Login from '@/components/Login'
import Clientes from '@/components/Clientes'
import Utilizadores from '@/components/Utilizadores'
import Extrato_Conta from '@/components/Extrato_Conta'
import Balancete_Analitico from '@/components/Balancete_Analitico'
import Balancete_Razao from '@/components/Balancete_Razao'
import Documentos from '@/components/Documentos'
import Notificacoes from '@/components/Notificacoes'
import Avisos from '@/components/Avisos'
import Escritorios from '@/components/Escritorios'
import Termos from '@/components/Termos'
import RelGestao from '@/components/RelGestao'
import Uploads from '@/components/Uploads'

Vue.use(Router)
Vue.component('Login', Login);

// -- TABLES
import Table_Utilizadores from '@/components/tables/Table_Utilizadores'
import Table_Clientes from '@/components/tables/Table_Clientes'
import Table_Extrato_Conta from '@/components/tables/Table_Extrato_Conta'
import Table_Balancete_Analitico from '@/components/tables/Table_Balancete_Analitico'
import Table_Balancete_Razao from '@/components/tables/Table_Balancete_Razao'
import Table_Documentos from '@/components/tables/Table_Documentos'
import Table_Notificacoes from '@/components/tables/Table_Notificacoes'
import Table_Avisos from '@/components/tables/Table_Avisos'
import Table_Escritorios from '@/components/tables/Table_Escritorios'

Vue.component('Table_Utilizadores', Table_Utilizadores);
Vue.component('Table_Clientes', Table_Clientes);
Vue.component('Table_Extrato_Conta', Table_Extrato_Conta);
Vue.component('Table_Balancete_Analitico', Table_Balancete_Analitico);
Vue.component('Table_Balancete_Razao', Table_Balancete_Razao);
Vue.component('Table_Documentos', Table_Documentos);
Vue.component('Table_Notificacoes', Table_Notificacoes);
Vue.component('Table_Avisos', Table_Avisos);
Vue.component('Table_Escritorios', Table_Escritorios);

// -- CHARTS
import Chart1 from '@/components/charts/Chart1'
import Chart2 from '@/components/charts/Chart2'
import Chart3 from '@/components/charts/Chart3'
import Chart4 from '@/components/charts/Chart4'
import Chart5 from '@/components/charts/Chart5'
import Chart6 from '@/components/charts/Chart6'
import Chart7 from '@/components/charts/Chart7'

Vue.component('Chart1', Chart1);
Vue.component('Chart2', Chart2);
Vue.component('Chart3', Chart3);
Vue.component('Chart4', Chart4);
Vue.component('Chart5', Chart5);
Vue.component('Chart6', Chart6);
Vue.component('Chart7', Chart7);


export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home
    },
    {
      path: '/utilizadores',
      name: 'utilizadores',
      component: Utilizadores
    },
    {
      path: '/clientes',
      name: 'clientes',
      component: Clientes
    },
    {
      path: '/extratos',
      name: 'extratos',
      component: Extrato_Conta
    },
    {
      path: '/balanceteanalitico',
      name: 'balanceteanalitico',
      component: Balancete_Analitico
    },
    {
      path: '/balanceterazao',
      name: 'balanceterazao',
      component: Balancete_Razao
    },
    {
      path: '/documentos',
      name: 'documentos',
      component: Documentos
    },
    {
      path: '/notificacoes',
      name: 'notificacoes',
      component: Notificacoes
    },
    {
      path: '/informacoes',
      name: 'informacoes',
      component: Avisos
    },
    {
      path: '/escritorios',
      name: 'escritorios',
      component: Escritorios
    },
    {
      path: '/termos',
      name: 'termos',
      component: Termos
    },
    {
      path: '/relatoriosgestao',
      name: 'relatoriosgestao',
      component: RelGestao
    },
    {
      path: '/uploads',
      name: 'uploads',
      component: Uploads
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js